var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRooms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 25.9026H19.65V26.0526V29.5263V29.6763H19.8H25.2C25.6393 29.6763 26.0596 29.8448 26.3686 30.143C26.6775 30.441 26.85 30.8441 26.85 31.2632C26.85 31.6823 26.6775 32.0853 26.3686 32.3834C26.0596 32.6816 25.6393 32.85 25.2 32.85H10.8C10.3607 32.85 9.94042 32.6816 9.63136 32.3834C9.32249 32.0853 9.15 31.6823 9.15 31.2632C9.15 30.8441 9.32249 30.441 9.63136 30.143C9.94042 29.8448 10.3607 29.6763 10.8 29.6763H16.2H16.35V29.5263V26.0526V25.9026H16.2H3.6C2.68331 25.9026 1.80519 25.5512 1.15857 24.9273C0.51213 24.3035 0.15 23.4587 0.15 22.5789V3.47368C0.15 2.59395 0.51213 1.74912 1.15857 1.12536C1.80519 0.501427 2.68331 0.15 3.6 0.15H32.4C33.3167 0.15 34.1948 0.501427 34.8414 1.12536C35.4879 1.74912 35.85 2.59395 35.85 3.47368V22.5789C35.85 23.4587 35.4879 24.3035 34.8414 24.9273C34.1948 25.5512 33.3167 25.9026 32.4 25.9026H19.8ZM32.4 22.7289H32.55V22.5789V3.47368V3.32368H32.4H3.6H3.45V3.47368V22.5789V22.7289H3.6H32.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/Rooms.7d19a5a4c306f65539557b593bcd2555.svg";
export { ForwardRef as ReactComponent };